import { styled, TableCell } from '@mui/material';
import React from 'react';


const TableCellCustom = styled(TableCell)(({ theme }) => ({
    borderRight: '1px solid black',
    borderLeft: '1px solid black',
    textAlign: 'center'
}));


export default TableCellCustom;